module.exports = __webpack_public_path__ + "static/media/01-galeria-01-bulgary@2x.92a67c8c.jpg";